import { render } from "./JobCategory.vue?vue&type=template&id=1534cdcb"
import script from "./JobCategory.vue?vue&type=script&lang=js"
export * from "./JobCategory.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__